/**
 * {key: 列头名称, value: {name: 字段名, width: 列宽, align: 居中方式, data_type: 数值类型}}
 * @type businessIncomeListExportStyle {是否挂车: {name: string, width: string, align: string, data_type: string}}
 */
const businessIncomeListExportStyle = {
    "是否有效": {
        name: "bool_covenant_alias", width: "50px", align: "center", data_type: "string"
    }, "订单ID": {
        name: "id", width: "50px", align: "center", data_type: "number"
    }, "父订单ID": {
        name: "pid", width: "50px", align: "center", data_type: "number"
    }, "订单类型": {
        name: "order_type_alias", width: "200px", align: "center", data_type: "string"
    }, "客户名称": {
        name: "customer_name", width: "200px", align: "center", data_type: "string"
    }, "是否年框": {
        name: "year_frame_alias", width: "200px", align: "center", data_type: "string"
    }, "乙方名称": {
        name: "company_name", width: "200px", align: "center", data_type: "string"
    }, "订单编号": {
        name: "order_no", width: "200px", align: "center", data_type: "string"
    }, "订单来源": {
        name: "order_source", width: "200px", align: "center", data_type: "string"
    }, "品牌": {
        name: "brand", width: "200px", align: "center", data_type: "string"
    }, "品牌集团": {
        name: "combine_brand_name", width: "200px", align: "center", data_type: "string"
    }, "产品/内容": {
        name: "product", width: "200px", align: "center", data_type: "string"
    }, "行业": {
        name: "trade", width: "200px", align: "center", data_type: "string"
    }, "性质": {
        name: "customer_nature", width: "200px", align: "center", data_type: "string"
    }, "客单": {
        name: "passenger_order_interval", width: "200px", align: "center", data_type: "string"
    }, "品类": {
        name: "product_category", width: "200px", align: "center", data_type: "string"
    }, "合作形式": {
        name: "form_of_cooperation", width: "200px", align: "center", data_type: "string"
    }, "项目名称": {
        name: "project_name", width: "200px", align: "center", data_type: "string"
    }, "策略人": {
        name: "strategy_name", width: "200px", align: "center", data_type: "string"
    }, "策划人": {
        name: "planner_name", width: "200px", align: "center", data_type: "string"
    }, "媒介人": {
        name: "medium_name", width: "200px", align: "center", data_type: "string"
    }, "要求发布时间": {
        name: "release_timestamp_alias", width: "200px", align: "center", data_type: "date"
    }, "红人名称": {
        name: "artist_nickname", width: "200px", align: "center", data_type: "string"
    }, "经纪人": {
        name: "agent_name", width: "200px", align: "center", data_type: "string"
    }, "分成比例": {
        name: "exec_rate", width: "200px", align: "right", data_type: "number"
    }, "红人分红": {
        name: "exec_artist_income", width: "200px", align: "right", data_type: "number"
    }, "公司收入": {
        name: "exec_company_income", width: "200px", align: "right", data_type: "number"
    }, "含税收入": {
        name: "payment_account", width: "200px", align: "right", data_type: "number"
    }, "下单金额": {
        name: "place_order_money", width: "200px", align: "right", data_type: "number"
    }, "标记开票": {
        name: "is_mark_invoiced_alias", width: "200px", align: "center", data_type: "string"
    }, "标记开票时间": {
        name: "mark_invoiced_time", width: "200px", align: "center", data_type: "string"
    }, "标记返点": {
        name: "is_mark_rebate_alias", width: "200px", align: "center", data_type: "string"
    }, "标记返点时间": {
        name: "mark_rebate_time", width: "200px", align: "center", data_type: "string"
    }, "发票状态": {
        name: "invoice_status_alias", width: "200px", align: "center", data_type: "string"
    }, "能否开票": {
        name: "is_can_invoice_alias", width: "200px", align: "center", data_type: "string"
    }, "已开票金额": {
        name: "invoice_money_done", width: "200px", align: "right", data_type: "number"
    }, "申请中开票金额": {
        name: "invoice_money_occupy", width: "200px", align: "right", data_type: "number"
    }, "开票时间": {
        name: "invoice_time", width: "200px", align: "center", data_type: "string"
    }, "发票开完": {
        name: "is_done_invoice_alias", width: "200px", align: "center", data_type: "string"
    }, "销售": {
        name: "sale_name", width: "200px", align: "center", data_type: "string"
    }, "销售小组": {
        name: "organization_name", width: "200px", align: "center", data_type: "string"
    }, "下单时间": {
        name: "created_timestamp_alias", width: "200px", align: "center", data_type: "date"
    }, "执行": {
        name: "executor_name", width: "200px", align: "center", data_type: "string"
    }, "执行时间": {
        name: "exec_at", width: "200px", align: "center", data_type: "date"
    }, "回款金额": {
        name: "sum_amount", width: "200px", align: "right", data_type: "number"
    }, "应收款": {
        name: "remain_account", width: "200px", align: "right", data_type: "number"
    }, "代下单平台费": {
        name: "platform_fee_po", width: "200px", align: "right", data_type: "number"
    }, "广告收入": {
        name: "adv_revenue", width: "200px", align: "right", data_type: "number"
    }, "税点": {
        name: "tax_point", width: "200px", align: "right", data_type: "number"
    }, "是否含税": {
        name: "bool_tax_alias", width: "200px", align: "center", data_type: "string"
    }, "粉丝福利": {
        name: "weal_price", width: "200px", align: "right", data_type: "number"
    }, "微任务所得": {
        name: "micro_task_income", width: "200px", align: "right", data_type: "number"
    }, "微任务价": {
        name: "micro_task_price", width: "200px", align: "right", data_type: "number"
    }, "执行价": {
        name: "exec_price", width: "200px", align: "right", data_type: "number"
    }, "授权价": {
        name: "authorized_price", width: "200px", align: "right", data_type: "number"
    }, "投流费": {
        name: "invest_flow_fee", width: "200px", align: "right", data_type: "number"
    }, "购物车费用": {
        name: "cart_charges", width: "200px", align: "right", data_type: "number"
    }, "直播坑位费": {
        name: "cart_commission", width: "200px", align: "right", data_type: "number"
    }, "其他费": {
        name: "other_fee", width: "200px", align: "right", data_type: "number"
    }, "返点金额": {
        name: "rebates_amount", width: "200px", align: "right", data_type: "number"
    }, "返点比例": {
        name: "rebates_rate", width: "200px", align: "right", data_type: "number"
    }, "是否挂车": {
        name: "is_trailer_alias", width: "200px", align: "center", data_type: "string"
    }, "挂车佣金(%)": {
        name: "commission_trailer", width: "200px", align: "right", data_type: "number"
    }, "是否直播": {
        name: "is_lb_alias", width: "200px", align: "center", data_type: "string"
    }, "是否保量": {
        name: "is_quantity_alias", width: "200px", align: "center", data_type: "string"
    }, "直播佣金(%)": {
        name: "commission_rate", width: "200px", align: "right", data_type: "number"
    }, "平台": {
        name: "platforms", width: "200px", align: "center", data_type: "string"
    }, "内容(发布)形式": {
        name: "content_forms", width: "200px", align: "center", data_type: "string"
    }, "坑位": {
        name: "ad_space", width: "200px", align: "center", data_type: "string"
    }, "发布链接": {
        name: "publish_link", width: "200px", align: "center", data_type: "string"
    }, "是否执行": {
        name: "bool_exec_alias", width: "200px", align: "center", data_type: "string"
    }, "回款状态": {
        name: "pay_status_alias", width: "200px", align: "center", data_type: "string"
    }, "结款方式": {
        name: "pay_method_alias", width: "200px", align: "center", data_type: "string"
    }, "结款时间": {
        name: "payed_timestamp_alias", width: "200px", align: "center", data_type: "string"
    }, "备注": {
        name: "remark", width: "200px", align: "center", data_type: "string"
    }, "收款形式": {
        name: "payment_method_alias", width: "200px", align: "center", data_type: "string"
    }, "合同归档": {
        name: "contract_filed_alias", width: "200px", align: "center", data_type: "string"
    }, "合同编号": {
        name: "contract_no", width: "200px", align: "center", data_type: "string"
    }, "合同金额": {
        name: "contract_amount", width: "200px", align: "right", data_type: "number"
    }, "财务备注": {
        name: "f_remark", width: "200px", align: "center", data_type: "string"
    }, "发票号码": {
        name: "invoice_number", width: "200px", align: "center", data_type: "string"
    }, "项目利润金额": {
        name: "money_achievement", width: "200px", align: "right", data_type: "number"
    }, "线下结佣": {
        name: "offline_rebate", width: "200px", align: "right", data_type: "number"
    }, "建单人": {
        name: "creator_name", width: "200px", align: "center", data_type: "string"
    }, "老客激活": {
        name: "activation_type_alias", width: "200px", align: "center", data_type: "string"
    }, "平台订单编号": {
        name: "oth_order_no", width: "200px", align: "center", data_type: "string"
    }, "创建时间": {
        name: "created_at", width: "200px", align: "center", data_type: "date"
    }, "修改时间": {
        name: "updated_at", width: "200px", align: "center", data_type: "date"
    }
}


export default businessIncomeListExportStyle